// src/assets/i18n/custom-translate-loader.ts
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, map, catchError, of } from 'rxjs';

export class CustomTranslateLoader implements TranslateLoader {
  private translations: any = null; 
  private readonly translationsFilePath = './assets/i18n/translations.json';

  constructor(private http: HttpClient) {}

  public getTranslation(lang: string): Observable<any> {
    if (this.translations) {
      return of(this.translations[lang] || {});
    }

    return this.http.get(this.translationsFilePath).pipe(
      map((response: any) => {
        this.translations = response; 
        return response[lang] || {};  
      }),
      catchError((error) => {
        console.error(`Error loading translations from ${this.translationsFilePath}:`, error);
        return of({}); 
      })
    );
  }
}